import React from "react";
import { useParams, Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import { FaArrowLeft } from "react-icons/fa";

const projectsData = {
  work1: {
    title: "CCTV Surveillance Hub",
    category: "CCTV & Access Control",
    description: "Our high-definition surveillance systems provide 24/7 monitoring, ensuring maximum security for corporate facilities and private properties.",
    images: [
      "/images/work1.png",
      "/images/camera1.png",
      "/images/cctv20.png",
      "/images/camera3.png"
    ]
  },
  work2: {
    title: "Perimeter Security",
    category: "Electric Fencing",
    description: "Advanced electric fencing and automated gate systems designed to deter and detect any unauthorized entry attempts with precision.",
    images: [
      "/images/work2.png",
      "/images/electric9.png",
      "/images/electric8.png",
      "/images/electric11.png"
    ]
  },
  work3: {
    title: "Gate Automation",
    category: "Gate Automation",
    description: "Smart and reliable gate automation systems providing seamless access and enhanced security for your home and office.",
    images: [
      "/images/gate1.png",
      "/images/gate2.png",
      "/images/work2.png",
      "/images/gate4.png"
    ]
   }
};

const WorksGallery = () => {
  const { projectId } = useParams();
  const project = projectsData[projectId];

  if (!project) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center text-center p-6">
        <h1 className="text-4xl font-bold text-brand-900 mb-4">Project Not Found</h1>
        <Link to="/" className="text-brand-600 hover:underline flex items-center gap-2">
          <FaArrowLeft /> Back to Home
        </Link>
      </div>
    );
  }

  return (
    <div className="font-poppins min-h-screen bg-white">
      <Navbar />
      
      {/* Header Section */}
      <section className="bg-brand-50 pt-32 pb-16">
        <div className="max-w-6xl mx-auto px-6">
          <Link to="/" className="inline-flex items-center gap-2 text-brand-600 font-semibold mb-6 hover:translate-x-1 transition-transform">
            <FaArrowLeft /> Back to Home
          </Link>
          <div className="max-w-3xl">
            <span className="text-xs font-bold uppercase tracking-wider text-brand-600 bg-brand-100 px-3 py-1 rounded-full">{project.category}</span>
            <h1 className="text-4xl md:text-5xl font-extrabold text-brand-950 mt-4 leading-tight">{project.title}</h1>
            <p className="text-gray-600 mt-6 text-lg leading-relaxed">{project.description}</p>
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-20">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid sm:grid-cols-2 lg:grid-cols-2 gap-8">
            {project.images.map((img, index) => (
              <div key={index} className="rounded-2xl overflow-hidden shadow-lg border border-brand-100 hover:shadow-xl transition-shadow duration-300">
                <img 
                  src={img} 
                  alt={`${project.title} - image ${index + 1}`} 
                  className="w-full h-[400px] object-cover"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer stripe */}
      <footer className="bg-brand-900 text-white py-12">
        <div className="max-w-6xl mx-auto px-6 text-center">
          <h2 className="text-2xl font-bold mb-4">Ready to secure your property?</h2>
          <p className="text-brand-100 mb-8 max-w-xl mx-auto">Get in touch with us for a professional assessment and installation.</p>
          <Link to="/contact" className="inline-flex items-center px-8 py-4 rounded-full bg-brand-accent text-white font-bold hover:bg-brand-400 transition-colors">
            Contact Us Today
          </Link>
        </div>
      </footer>
      
      <div className="text-center text-gray-500 text-sm py-6 bg-brand-50">
          <p>© {new Date().getFullYear()} Gesingo Security Technology</p>
          <p className="mt-1">Designed by <a href="https://wa.me/233545038856" className="text-brand-600 hover:underline" target="_blank" rel="noopener noreferrer">WASS TECH SOLUTIONS</a></p>
      </div>
    </div>
  );
};

export default WorksGallery;
